import { ChangeEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutTopCarrierReport } from "./autogen/AutogenLayoutTopCarrierReport";

export class TopCarrierReport extends AutogenLayoutTopCarrierReport {
    override onLoad(){
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.textboxRankBy.selectedItem = this.textboxRankBy.items[0];
        this.textboxDateType.selectedItem = this.textboxDateType.items[0];
    }

    switchComparePeriodsOnChange() {
        const comparingPeriods = this.switchComparePeriods.checked;
        this.textboxStartTwo.enabled = comparingPeriods;
        this.textboxStartTwo.required = comparingPeriods;
        this.textboxStartTwo.requiredDuringSearch = comparingPeriods;
        if (comparingPeriods === false)
            this.textboxStartTwo.resetValidation();
    }

    textboxDateTypeOnChange(event: ChangeEvent) {
        const dateDisplayValue = (event.target as Textbox).selectedItem?.displayValue ?? "";
        this.textboxShipDate.caption = "Period 1 " + dateDisplayValue;
        this.textboxStartTwo.caption = "Period 2 " + dateDisplayValue;
    }

    textboxGroupByOnChange(event: ChangeEvent) {
        const groupByValue = (event.target as Textbox).selectedItem?.value;
        this.checkboxPageBreak.enabled = groupByValue !== "N";
    }
}
